<template>
    <div  :id="id"  :key="id" style="width: 100%;height:500px;"></div>
</template>

<script>
  import "../../../static/plugin/ueditor/ueditor.config"
  import "../../../static/plugin/ueditor/ueditor.all"
  import "../../../static/plugin/ueditor/ueditor.parse"
  import "../../../static/plugin/ueditor/lang/zh-cn/zh-cn"
  import "../../../static/plugin/ueditor/themes/default/css/ueditor.css"

  export default {
    props:{
      id:{
        type:String,
        default:'ueditor'
      }
    },
    name: "ueditor",
    data() {
      return {
        ueditorText:null,
      }
    },
    mixins: [tableBase],
    methods: {
      setContent(content,isAppend){
        if(isAppend){
          this.ueditorText.execCommand('inserthtml',content);
        }else{
          this.ueditorText.setContent(content);
        }
      },
      getContent(){
        return this.ueditorText.getContent();
      },
      init(content){
        if(!this.ueditorText){
          this.ueditorText = UE.getEditor(this.id);
        }
        this.ueditorText.ready(()=>{
          this.ueditorText.setHeight(500);
          this.ueditorText.setContent("");
          this.ueditorText.execCommand('insertHtml',content);
        });
      }
    },
    mounted() {
      UE.delEditor(this.id);
      let token = this.getQiNiuToken();
      localStorage.setItem('qc_qiniu_token',token);
      setTimeout(()=>{
        this.ueditorText = UE.getEditor(this.id,{autoHeightEnabled: false});
      },500);
    },
    destroyed(){
      if(this.ueditorText !== null && this.ueditorText.destroy) {
        this.ueditorText.destroy();
      }
    }
  }
</script>


<style lang="less" scoped>

</style>
